import { useGetUserRulesQuery } from '@generated/graphql';
import { useEditRulesModal } from './EditRulesModal';
import { RulesCard } from './RulesCard';

export const UserRulesCard = ({
  startOpen = false,
  showUserRulesWarning = true,
  flex = false,
}: {
  startOpen?: boolean;
  showUserRulesWarning?: boolean;
  flex?: boolean;
}) => {
  const { data: userRulesData } = useGetUserRulesQuery();
  const userRules = userRulesData?.getUserRules || '';

  const { showEditRulesModal } = useEditRulesModal({
    componentProps: { reloadKey: 'user-edit-rules' },
    modalProps: {
      title: 'Edit user rules',
    },
  });
  const handleEdit = () => {
    showEditRulesModal({ currentRules: userRules });
  };

  return (
    <RulesCard
      rules={userRules}
      source="user"
      startOpen={startOpen}
      showUserRulesWarning={showUserRulesWarning}
      flex={flex}
      onEdit={handleEdit}
    />
  );
};
